<template>
  <v-navigation-drawer
    v-if="$store.state.admin.connected"
    id="app-drawer"
    v-model="inputValue"
    app
    class="drawer"
    dark
    floating
    mini-variant-width="80"
    persistent
    mini-variant
  >
    <template v-slot:img="attrs">
      <v-img
        v-bind="attrs"
        gradient="to top, rgba(0, 0, 0, .55), rgba(0, 0, 0, .7)"
      />
    </template>

    <template v-slot:prepend>
      <v-list-item two-line>
        <v-list-item-avatar dark>
          <v-img src="@/assets/Logo-format-Twitter.jpg" height="40" contain />
        </v-list-item-avatar>

        <v-list-item-title class="title"> CLEED.AI </v-list-item-title>
      </v-list-item>

      <v-divider class="mx-3 mb-3" />
    </template>

    <v-list link :disabled="!$store.state.admin.connected">
      <v-menu
        v-model="showMenu"
        rounded="b-xl tr-xl"
        offset-x
        style="max-width: 600px"
      >
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip color="rgb(17, 65, 206)" right>
            <template v-slot:activator="{ on: tooltip }">
              <v-list-item
                color="#a7a7a7"
                v-bind="attrs"
                v-on="{ ...tooltip, ...menu }"
                active-class="link_active"
              >
                <v-badge
                  :content="$store.state.notification.notif"
                  :value="$store.state.notification.notif"
                  color="red"
                  overlap
                  bordered
                  right
                >
                  <v-btn icon disabled :loading="messanger_loader">
                    <v-row no-gutters justify="center" align="center">
                      <v-col cols="auto" class="ml-1">
                        <v-icon
                          :color="
                            $store.state.link.to === '/messages'
                              ? '#ffffff'
                              : '#505a69'
                          "
                          size="27"
                        >
                          mdi-email
                        </v-icon>
                      </v-col>
                      <v-col cols="1">
                        <v-icon dark>mdi-menu-right</v-icon>
                      </v-col>
                    </v-row>
                  </v-btn>
                </v-badge>
              </v-list-item>
            </template>
            <span>{{ get_labeles("Messenger") }}</span>
          </v-tooltip>
        </template>
        <v-list dense>
          <v-subheader class="ma-0">Context</v-subheader>
          <v-list-item-group
            v-model="$store.state.messanger_type_selected"
            color="primary"
          >
            <v-list-item
              v-for="(item, i) in $store.state.messangerItems"
              :key="i"
              link
              color="cleed_blue"
              dense
              :disabled="
                $store.state.messanger_type_selected === i ? true : false
              "
              @click="select_messanger_type(i)"
            >
              <v-list-item-icon class="ml-1 mr-5">
                <cleed-icon
                  class="mb-1"
                  :icon="item.icon"
                  :width="item.width"
                  :height="item.height"
                  :dark="true"
                />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  class="font-weight-bold"
                  v-text="$t(`drawer.contexts.${item.mode}`)"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <v-list-item
        v-for="(link, i) in [...links, ...$store.state.app_drawer_links]"
        :key="i"
        :to="link.to"
        color="#a7a7a7"
        active-class="link_active"
      >
        <!-- other tabs -->
        <v-tooltip color="rgb(17, 65, 206)" right>
          <template v-slot:activator="{ on }">
            <v-list-item-icon v-on="on">
              <v-icon
                class="icon"
                color="#505a69"
                :size="link.icon_size || '27'"
              >
                {{ link.icon }}
              </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{
                get_labeles(link.text)
              }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <span>{{ get_labeles(link.text) }}</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item
        v-if="$store.state.shopify.show_btn"
        :to="shopifyBtn.to"
        color="#a7a7a7"
        @click="$store.state.link = shopifyBtn"
      >
        <v-tooltip color="rgb(17, 65, 206)" right>
          <template v-slot:activator="{ on }">
            <span
              v-on="on"
              :style="
                $store.state.link.to === shopifyBtn.to
                  ? 'color : #ffffff;'
                  : 'color : #505a69;'
              "
              v-html="shopifyBtn.icon_svg"
            >
            </span>
          </template>
          <span>{{ get_labeles(shopifyBtn.text) }}</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
    <template v-slot:append>
      <v-divider class="mx-3 mb-3" />
      <v-tooltip color="rgb(17, 65, 206)" right>
        <template v-slot:activator="{ on }">
          <v-list-item
            v-on="on"
            to="/Settings"
            color="#a7a7a7"
            active-class="link_active"
          >
            <v-list-item-icon v-on="on">
              <v-icon class="icon" color="#505a69" :size="25"> mdi-cog </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{
                get_labeles("settings")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ "settings" }}</span>
      </v-tooltip>

      <div class="pa-2">
        <v-img src="@/assets/footer-logo.svg" height="30" width="96%" contain />
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState } from "vuex";
import CleedIcon from "./CleedIcon.vue";

export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CleedIcon,
  },
  data() {
    return {
      links: [],
      links_appended: [],
      showMenu: null,
      messanger_loader: false,
      shopifyBtn: {
        to: "/Shopify",
        icon_svg: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          aria-hidden="true" role="img" width="26" height="26" preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 32 32">
          <path d="M20.448 31.974l9.625-2.083s-3.474-23.484-3.5-23.641s-.156-.255-.281-.255c-.13 0-2.573-.182-2.573-.182s-1.703-1.698-1.922-1.88a.415.415 0 0 0-.161-.099l-1.219 28.141zm-4.833-16.901s-1.083-.563-2.365-.563c-1.932 0-2.005 1.203-2.005 1.521c0 1.641 4.318 2.286 4.318 6.172c0 3.057-1.922 5.01-4.542 5.01c-3.141 0-4.719-1.953-4.719-1.953l.859-2.781s1.661 1.422 3.042 1.422c.901 0 1.302-.724 1.302-1.245c0-2.156-3.542-2.255-3.542-5.807c-.047-2.984 2.094-5.891 6.438-5.891c1.677 0 2.5.479 2.5.479l-1.26 3.625zm-.719-13.969c.177 0 .359.052.536.182c-1.313.62-2.75 2.188-3.344 5.323a76.43 76.43 0 0 1-2.516.771c.688-2.38 2.359-6.26 5.323-6.26zm1.646 3.932v.182c-1.005.307-2.115.646-3.193.979c.62-2.37 1.776-3.526 2.781-3.958c.255.667.411 1.568.411 2.797zm.718-2.973c.922.094 1.521 1.151 1.901 2.339c-.464.151-.979.307-1.542.484v-.333c0-1.005-.13-1.828-.359-2.495zm3.99 1.718c-.031 0-.083.026-.104.026c-.026 0-.385.099-.953.281C19.63 2.442 18.625.927 16.849.927h-.156C16.183.281 15.558 0 15.021 0c-4.141 0-6.12 5.172-6.74 7.797c-1.594.484-2.75.844-2.88.896c-.901.286-.927.313-1.031 1.161c-.099.615-2.438 18.75-2.438 18.75L20.01 32z" fill="currentColor"/>
          </svg>`,
        icon_size: "32",
        text: "shopify",
      },
    };
  },

  computed: {
    ...mapState("app", ["image", "color"]),
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
  },
  mounted() {
    this.links_appended = [
      {
        to: "/Settings",
        icon: "mdi-cog",
        text: "settings",
      },
    ];

    this.links = [
      {
        to: "/",
        icon: "mdi-chart-bell-curve-cumulative",
        text: "Analytics",
      },
      {
        to: "/Userinfos",
        icon: "mdi-account-search",
        text: "Users",
      },
      {
        to: "/looks",
        icon: "mdi-tshirt-crew",
        text: "Looks",
      },
      {
        to: "/selectItems",
        icon: "mdi-hanger",
        text: "labelling",
      },
      {
        to: "/i18n",
        icon: "mdi-code-braces",
        text: "Wording",
      },
      {
        to: "/VisualSearch",
        icon: "mdi-compare",
        text: "similarity",
      },
      {
        to: "/EmailApiDetails",
        icon: "mdi-email-edit",
        text: "email_details",
      },
    ];
    if (this.$store.state.admin.super_actions) this.cleed_super_action();
    //fetch openAi config
    this.$store
      .dispatch("FETCH_LLM_CONFIG")
      .then(() => {
        console.log("store with openai feature");
      })
      .catch(() => console.log("store without openai feature"));
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    get_labeles(name) {
      return this.$t(`drawer.${name}`);
    },
    cleed_super_action() {
      if (this.$store.state.admin.super_actions)
        this.links.push({
          to: "/Admin_i18n",
          icon: "mdi-shield-account",
          text: "Wording",
        });
    },
    async select_messanger_type(i) {
      this.$store.state.link = {
        to: "/messages",
        icon: "mdi-email",
        text: "Messenger",
      };
      this.$store.state.messanger_type_selected = i;
      this.$store.state.messages.loading = true;
      this.$store.dispatch("setCloader", {
        showing: true,
        text: "please wait..",
      });
      if (this.$route.name !== "Messages") {
        this.messanger_loader = true;
        await this.$store
          .dispatch("FETCH_MESSAGES", {
            page: 0,
            type: this.$store.state.messanger_type_selected,
          })
          .then((r) => {
            this.$router.push({ path: "/messages" });
            this.messanger_loader = false;
            this.$store.state.messages.api_msg_pull = 0;
            this.$store.state.messages.loading = false;
            this.$store.dispatch("setCloader", {
              showing: false,
            });
            this.$store.state.messages.last_page = 1;
            if (this.$store.state.show.chat === true) {
              this.$store.state.show.dash = true;
              this.$store.state.show.chat = false;
            }
          })
          .catch((err) => {
            this.$store.dispatch("setCloader", {
              showing: false,
            });
            this.$store.state.messages.loading = false;
            this.messanger_loader = false;
            console.log(err);
          });
      } else {
        this.messanger_loader = true;
        await this.$store
          .dispatch("FETCH_MESSAGES", {
            page: 0,
            type: this.$store.state.messanger_type_selected,
          })
          .then((r) => {
            this.messanger_loader = false;
            this.$store.state.messages.api_msg_pull = 0;
            this.$store.state.messages.loading = false;
            this.$store.dispatch("setCloader", {
              showing: false,
            });
            this.$store.state.messages.last_page = 1;
            if (this.$store.state.show.chat === true) {
              this.$store.state.show.dash = true;
              this.$store.state.show.chat = false;
            }
          })
          .catch((err) => {
            this.$store.dispatch("setCloader", {
              showing: false,
            });
            this.$store.state.messages.loading = false;
            this.messanger_loader = false;
            console.log(err);
          });
      }
    },
  },
};
</script>

<style scoped>
.drawer {
  background-image: -webkit-gradient(
    linear,
    right bottom,
    left center,
    color-stop(0, #71829c),
    to(#263767)
  );
}
.link_active .icon {
  color: #ffffff !important;
}
</style>
